import { SELECT_REGISTRATION_STATION } from "../constants"

const initialState = {
  data: {}
}

export default function selectRegistrationStationReducer (state = initialState, action) {
  switch (action.type) {
    case SELECT_REGISTRATION_STATION:
      return {
        ...state,
        data: action.payload
      }
    
    default:
      return state
  }
}
